module.exports = __webpack_public_path__ + "img/status-10.b9b569dd.png";